import { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { removeLoginLS } from "@delibrandev/utils";
import { apiRest } from "../api/constants";
import { logOut } from "../api/login";
import { setAlert, setUserLogOut } from "../reducers/userConfigSlice";

export const LOGOUT_EVENT_KEY = "delibran.admin.logout";

export function useLogoutSync() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const logged = useSelector((state) => state.aplicationConfig.userConfig.logged);
  useEffect(() => {
    const onStorage = (event) => {
      if (event.storageArea !== localStorage || event.key !== LOGOUT_EVENT_KEY || !event.newValue || !logged) return;
      removeLoginLS(apiRest);
      dispatch(setUserLogOut());
      dispatch(setAlert({ title: "Sesión cerrada", message: "Has cerrado la sesión en otra pestaña.", type: "info" }));
      navigate("/", { replace: true });
    };
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, [dispatch, navigate, logged]);
}

export function useLogout() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const pending = useRef(false);
  const [loggingOut, setLoggingOut] = useState(false);
  const logout = useCallback(async () => {
    if (pending.current) return;
    pending.current = true;
    setLoggingOut(true);
    try {
      const response = await logOut();
      if (response?.error !== false) throw new Error("Logout not confirmed");
      removeLoginLS(apiRest);
      dispatch(setUserLogOut());
      // A separate signal also works when the user did not save login credentials.
      localStorage.setItem(LOGOUT_EVENT_KEY, `${Date.now()}-${Math.random()}`);
      navigate("/", { replace: true });
    } catch {
      dispatch(setAlert({ title: "No se ha cerrado la sesión", message: "No hemos podido confirmar el cierre. Comprueba tu conexión y vuelve a pulsar Cerrar sesión.", type: "error" }));
    } finally {
      pending.current = false;
      setLoggingOut(false);
    }
  }, [dispatch, navigate]);
  return { logout, loggingOut };
}
